import React, { useState } from 'react';
import './Reset.css';
import axios from 'axios';
import { serverUrl } from '../../../../Constant/Static/config';
import Header from '../../../Registration/Header';
import peopleIcon from '../../../../Constant/Icons/people.svg';
import passwordIcon from '../../../../Constant/Icons/password.svg';
import eyeIcon from '../../../../Constant/Icons/eye.svg';
import user from '../../../../Constant/Icons/user.svg';
import eyeSlashIcon from '../../../../Constant/Icons/eyehide.svg';
import PopModal from '../../../../Constant/Custom/Models/PopModal';
import { useNavigate } from 'react-router-dom';

const CollegeResetPassword = () => {

  const collegeCode = sessionStorage.getItem('collegeCode');

  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const navigate = useNavigate();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.newPassword || !formData.confirmPassword) {
      setModalType({
        icon: 'warning',
        title: 'Invalid Input',
        text: 'Both password fields are required.',
      });
      openModal();
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setModalType({
        icon: 'warning',
        title: 'Password Mismatch',
        text: 'New password and confirm password do not match.',
      });
      openModal();
      return;
    }

    const dataToSend = {
      collegeCode: collegeCode,
      newPassword: formData.newPassword.trim(),
    };

    try {
      const response = await axios.post(`${serverUrl}/api/college/reset-password`, dataToSend);
      if (response.status === 200) {
        setModalType({
          icon: 'success',
          title: 'Password Reset Successful!',
          text: response.data.message,
        });
        openModal();
        sessionStorage.removeItem('collegeCode');
        setTimeout(() => {
          navigate('/college-login');
        }, 2000);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'An error occurred. Please try again.';
      setModalType({
        icon: 'error',
        title: 'Password Reset Failed!',
        text: errorMessage,
      });
      openModal();
    }
  };

  const handleCancel = () => {
    setFormData({
      newPassword: '',
      confirmPassword: '',
    });
    closeModal();
  };

  return (
    <div style={{ width: '100dvw', height: '100dvh', backgroundColor: '#f9f9f9' }}>

      <Header>
        <a href="/college-login">
          <img src={user} alt="Login" width={50} height={50} />
        </a>
      </Header>

      <div className="reset-password-container">
        <div className="reset-password-inner-container">
          <h1 style={{ textAlign: "center" }}>RESET PASSWORD</h1>
          <img src={peopleIcon} alt="user" width={75} height={75} />
          <form onSubmit={handleSubmit}>
            <div className="reset-password-form-group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="newPassword"
                value={formData.newPassword}
                placeholder="Enter New Password"
                onChange={handleChange}
                required
              />
              <img className="IconForInput" src={passwordIcon} alt="password" width={20} height={20} />
              <button
                type="button"
                className="toggle-password"
                onClick={handlePasswordVisibility}
                aria-label={showPassword ? 'Hide Password' : 'Show Password'}
              >
                <img src={showPassword ? eyeSlashIcon : eyeIcon} alt="toggle password visibility" width={20} height={20} />
              </button>
            </div>
            <div className="reset-password-form-group">
              <input
                type={showPassword ? 'text' : 'password'}
                name="confirmPassword"
                value={formData.confirmPassword}
                placeholder="Confirm New Password"
                onChange={handleChange}
                required
              />
              <img className="IconForInput" src={passwordIcon} alt="password" width={20} height={20} />
              <button
                type="button"
                className="toggle-password"
                onClick={handlePasswordVisibility}
                aria-label={showPassword ? 'Hide Password' : 'Show Password'}
              >
                <img src={showPassword ? eyeSlashIcon : eyeIcon} alt="toggle password visibility" width={20} height={20} />
              </button>
            </div>
            <div className="reset-password-form-group">
              <button type="submit" className="reset-password-button">Reset Password</button>
            </div>

          </form>

          {/* <div
            style={{
              position: 'relative',
              alignSelf: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <svg
              height={10}
              width="100%"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="0%"
                y1="55%"
                x2="100%"
                y2="55%"
                style={{
                  stroke: '#1C274C',
                  strokeWidth: 0.25,
                  filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
                }}
              />
            </svg> */}
          {/* <div
              style={{
                position: 'absolute',
                backgroundColor: '#f9f9f9',
                padding: '5px 5px',
                borderRadius: '50%',
                zIndex: '1000',
              }}
            >
              <h6 style={{ margin: 0 }}>Or</h6>
            </div> */}
          {/* </div> */}
          <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <PopModal
              isOpen={isModalOpen}
              type={modalType}
              confirmButtonText="OK"
              onConfirm={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollegeResetPassword;